import { html } from './utils/core.js';
import { hydrate } from 'preact';
import App from './App.js';

hydrate(html`<${App}/>`, document.getElementById('root'));